import { useEffect, useRef, useState } from 'react';
import api from '@/lib/api';

export default function SharePointMicrosoftCallback() {
  const started = useRef(false);
  const [error, setError] = useState('');
  useEffect(() => {
    if (started.current) return;
    started.current = true;
    const params = new URLSearchParams(window.location.hash.slice(1));
    // Remove the authorization response before any subsequent navigation.
    window.history.replaceState(null, '', window.location.pathname);
    const state = params.get('state');
    if (!state) { setError('This connection attempt is missing or expired. Return to Connectors and start again.'); return; }
    api.post('/sharepoint-microsoft/finish', {
      state, code: params.get('code') || '', error: params.get('error') || '',
    }).then(({ data }) => {
      window.location.replace(`/connectors?microsoft_connection=${encodeURIComponent(data.id)}`);
    }).catch(e => {
      const detail = e.response?.data?.detail;
      setError(typeof detail === 'string' ? detail : detail?.message || 'Microsoft connection could not be completed. Return to Connectors and try again.');
    });
  }, []);
  return <main className="max-w-lg mx-auto p-8 space-y-4">
    <h1 className="text-xl font-semibold">Connect SharePoint</h1>
    {error ? <><p role="alert">{error}</p><a className="underline" href="/connectors">Return to Connectors</a></> : <p role="status">Completing Microsoft sign-in...</p>}
  </main>;
}
